import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Prestijli tarayıcı sekme başlığı yöneticisi.
 *
 * `useLocation` ile pathname değişir değişmez `document.title`'ı
 * "Sayfa | MİLYEMSOFT" formatına oturtur. Landing için sadece "MİLYEMSOFT".
 *
 * Data-testid gerekmez — DOM'a hiçbir şey render etmez.
 */
const TITLES = {
  "/": "",
  "/login": "Giriş",
  "/signup": "Kayıt",
  "/forgot-password": "Şifremi Unuttum",
  "/auth/callback": "Doğrulama",
  "/pricing": "Fiyatlandırma",
  "/subscription": "Abonelik",
  "/billing/success": "Ödeme Başarılı",
  "/billing/cancel": "Ödeme İptal",
  "/dashboard": "Panel",
  "/products": "Ürünler",
  "/stock-alerts": "Stok Uyarıları",
  "/pos": "POS",
  "/karats": "Ayar Yönetimi",
  "/customers": "Müşteriler",
  "/vault": "Kasa",
  "/accounts": "Cari Hesaplar",
  "/analytics": "Analiz",
  "/cashcount": "Kasa Sayımı",
  "/vision": "AI Vitrin",
  "/chat": "AI Sohbet",
  "/spectro": "Spektrometre",
  "/notify": "Bildirimler",
  "/z-report": "Z Raporu",
  "/settings": "Ayarlar",
  "/users": "Kullanıcılar",
  "/superadmin": "SüperAdmin",
  "/signage": "Vitrin Ekranı",
  "/iletisim": "İletişim",
  "/legal/mesafeli-satis": "Mesafeli Satış",
  "/legal/iptal-iade": "İptal ve İade",
  "/legal/gizlilik-kvkk": "KVKK ve Gizlilik",
  "/legal/hizmet-teslimati": "Hizmet Teslimatı",
  "/legal/kullanim-kosullari": "Kullanım Koşulları",
};

export default function RouteTitle() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    // Exact match önce; sonra dinamik: /customers/:id gibi
    let page = TITLES[path];
    if (page === undefined) {
      if (path.startsWith("/customers/")) page = "Müşteri Detayı";
      else page = "";
    }
    document.title = page ? `${page} | MİLYEMSOFT` : "MİLYEMSOFT";
  }, [location.pathname]);
  return null;
}
